import React from "react";
import { Box, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup, } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ClientsAutocomplete } from "frontend/src/domain/client";
var useStyles = makeStyles({
    group: {
        flexDirection: "row",
    },
});
export var SelectMusicArchiveType = function (_a) {
    var type = _a.type, client = _a.client;
    var classes = useStyles();
    return (React.createElement(Box, null,
        type.value === "private" && (React.createElement(ClientsAutocomplete, { label: "Клиент", value: client.value, onChange: client.onChange })),
        React.createElement(FormGroup, { row: true },
            React.createElement(Box, { mt: 1 },
                React.createElement(FormControl, { component: "fieldset" },
                    React.createElement(RadioGroup, { name: "type", value: type.value, className: classes.group, onChange: function (evt) {
                            if (evt.target.value === "private") {
                                type.onChange("private");
                            }
                            else {
                                type.onChange("public");
                            }
                        } },
                        React.createElement(FormControlLabel, { value: "public", control: React.createElement(Radio, null), label: "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439" }),
                        React.createElement(FormControlLabel, { value: "private", control: React.createElement(Radio, null), label: "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439" })))))));
};
